import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { ref, watch } from 'vue'
interface IProps {
  status?: {
    info?: String
    imgSrc?: String
  },
  selfStyle?: Object
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Error',
  props: {
    status: { default: () => {
    return {
      info: '',
      imgSrc: ''
    }
  } },
    selfStyle: { default: () => {
    return {}
  } }
  },
  setup(__props: any) {

const props = __props
const info = ref<String>(props.status?.info || '暂无内容')
const imgSrc = ref(props.status.imgSrc ? require('@/assets/images/empty/' + props.status?.imgSrc) : require('@/assets/images/empty/empty.png'))
watch(
  () => props.status,
  (newValue) => {
    info.value = newValue.info || '暂无内容'
    imgSrc.value = newValue.imgSrc ? require('@/assets/images/empty/' + newValue.imgSrc) : require('@/assets/images/empty/empty.png')
  },
  { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["error_container", imgSrc.value.includes('cont') ? 'error_cont' : '']),
    style: _normalizeStyle({..._ctx.selfStyle})
  }, [
    _createElementVNode("img", {
      src: imgSrc.value,
      alt: "",
      class: _normalizeClass(["img", imgSrc.value.includes('cont') ? 'img_cont' : ''])
    }, null, 10, _hoisted_1),
    _createElementVNode("span", null, _toDisplayString(info.value), 1)
  ], 6))
}
}

})